import Http from '@/services/http';

const urls = {
  base: '/ReleaseNotes',
};

export default {
  getReleaseNotes(language) {
    const http = new Http();
    return http.get(`${urls.base}/${language}`).then(response => response.data);
  },
};
